module.exports = __webpack_public_path__ + "img/card.a4faf8ce.jpeg";